import theme from '.';

const viewport = {
  mobileS: `(max-width: ${theme.screenSize.mobileS})`,
};

export default viewport;
